enum GUEST_FORM_NAMES {
  name = 'name',
  surname = 'surname',
  second_surname = 'second_surname',
  birth_date = 'birth_date',
  gender = 'gender',
  nationality = 'nationality',
  citizenship = 'citizenship',
  document_type = 'document_type',
  document_number = 'document_number',
  document_issue_date = 'document_issue_date',
  document_expiration_date = 'document_expiration_date',
  document_expedition_country = 'document_expedition_country',
  document_expedition_city = 'document_expedition_city',
  document_expedition_municipality = 'document_expedition_municipality',
  visa_number = 'visa_number',
  purpose_of_stay = 'purpose_of_stay',
  tax_exemption = 'tax_exemption',
  full_tourist_tax = 'full_tourist_tax',
  birth_place_country = 'birth_place_country',
  birth_place_city = 'birth_place_city',
  birth_place_address = 'birth_place_address',
  birth_place_municipality = 'birth_place_municipality',
  residence_country = 'residence_country',
  residence_community = 'residence_community',
  residence_city = 'residence_city',
  residence_province = 'residence_province',
  residence_address = 'residence_address',
  residence_street = 'residence_street',
  residence_house_number = 'residence_house_number',
  residence_postal_code = 'residence_postal_code',
  residence_municipality = 'residence_municipality',
  arrived_from_country = 'arrived_from_country',
  arrived_from_district = 'arrived_from_district',
  arrived_from_municipality = 'arrived_from_municipality',
  arrived_from_province = 'arrived_from_province',
  next_destination_country = 'next_destination_country',
  next_destination_district = 'next_destination_district',
  next_destination_province = 'next_destination_province',
  next_destination_address = 'next_destination_address',
  next_destination_municipality = 'next_destination_municipality',
  fiscal_code = 'fiscal_code',
  email = 'email',
  phone = 'phone',
  second_phone = 'second_phone',
  document_front_side_scan = 'document_front_side_scan',
  document_back_side_scan = 'document_back_side_scan',
  signature = 'signature',
  document_support_number = 'document_support_number',
  kinship_relationship = 'kinship_relationship',
  external_category_id = 'external_category_id',
  invoice_leader_type = 'invoice_leader_type',
  recipient_code_type = 'recipient_code_type',
  contract_email = 'contract_email',
  agreement_clauses = 'agreement_clauses',
  vat_number = 'vat_number',
  recipient_code = 'recipient_code',
  chip_card = 'chip_card',
  mode_of_transport = 'mode_of_transport',
}

enum FIELD_TYPES {
  text = 'TEXT',
  date = 'DATE',
  file = 'FILE',
  time = 'TIME',
  select = 'SELECT',
  phone = 'PHONE',
  datePicker = 'DATEPICKER',
  signature = 'SIGNATURE',
  number = 'NUMBER',
  hidden = 'HIDDEN',
}

export {FIELD_TYPES, GUEST_FORM_NAMES};
